import React, { ImgHTMLAttributes } from 'react';

type Props = ImgHTMLAttributes<SVGElement>;

const IdTypeVisa: React.FC<Props> = ({ className }) => (
  // eslint-disable-next-line react/jsx-props-no-spreading
  <svg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg' className={className}>
    <path
      d='M7.25 9.50146C7.25 9.08725 7.58579 8.75146 8 8.75146H16C16.4142 8.75146 16.75 9.08725 16.75 9.50146C16.75 9.91568 16.4142 10.2515 16 10.2515H8C7.58579 10.2515 7.25 9.91568 7.25 9.50146Z'
      fill='currentColor'
    />
    <path
      d='M8 12.7515C7.58579 12.7515 7.25 13.0873 7.25 13.5015C7.25 13.9157 7.58579 14.2515 8 14.2515H16C16.4142 14.2515 16.75 13.9157 16.75 13.5015C16.75 13.0873 16.4142 12.7515 16 12.7515H8Z'
      fill='currentColor'
    />
    <path
      d='M7.25 17.5015C7.25 17.0873 7.58579 16.7515 8 16.7515H12C12.4142 16.7515 12.75 17.0873 12.75 17.5015C12.75 17.9157 12.4142 18.2515 12 18.2515H8C7.58579 18.2515 7.25 17.9157 7.25 17.5015Z'
      fill='currentColor'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M3.25 5.25C3.25 3.45507 4.70507 2 6.5 2H17.5C19.2949 2 20.75 3.45507 20.75 5.25V18.75C20.75 20.5449 19.2949 22 17.5 22H6.5C4.70507 22 3.25 20.5449 3.25 18.75V5.25ZM19.25 6H4.75V18.75C4.75 19.7165 5.5335 20.5 6.5 20.5H17.5C18.4665 20.5 19.25 19.7165 19.25 18.75V6Z'
      fill='currentColor'
    />
  </svg>
);

export { IdTypeVisa };
